import { Directive, inject, Renderer2 } from '@angular/core';

@Directive({
  selector: '[idpInspirationSubNavContainerBase]',
  standalone: true
})
export class InspirationSubNavContainerBaseDirective {
  inspirationSubNavClicked = false;
  isInspireMenu!: boolean;
  isLegacyApp!: boolean;
  headerHeight = 0;

  rend = inject(Renderer2);

  calculateTotalHeight(): number {
    const alertHeight = this.getElementHeight(
      '.idp-alert-advisories-container'
    );
    const navHeight = this.getElementHeight('.header__top');
    const bookingTabsHeight = this.getElementHeight('.header__booking');
    const widgetHeight = this.inspirationSubNavClicked
      ? 0
      : this.getElementHeight('.header__widgets');
    return alertHeight + navHeight + bookingTabsHeight + widgetHeight;
  }

  getElementHeight(selector: string): number {
    const element = document.body.querySelector(selector);
    return element ? (element as HTMLElement).offsetHeight : 0;
  }

  updateSubNavMargin(): void {
    const subNav = document.querySelector(
      '.inspiration-sub-nav-container'
    ) as HTMLElement;
    if (!subNav) return;

    const alertHeight = this.getElementHeight(
      '.idp-alert-advisories-container'
    );
    const headerTopHeight = this.getElementHeight('.header__top');
    const bookingTabsHeight = this.getElementHeight('.header__booking');
    const widgetHeight = this.inspirationSubNavClicked
      ? 0
      : this.getElementHeight('.header__widgets');
    const top =
      alertHeight + headerTopHeight + bookingTabsHeight + widgetHeight;
    this.rend.setStyle(subNav, 'top', `${top}px`);
  }

  positionSubNav(): void {
    const headerWidgets = document.querySelector(
      '.header__widgets'
    ) as HTMLElement | null;
    const widgetIsFixed = headerWidgets
      ? getComputedStyle(headerWidgets).position === 'fixed'
      : false;

    if (window.scrollY > 0 && !widgetIsFixed) {
      const alertHeight = this.getElementHeight(
        '.idp-alert-advisories-container'
      );
      const headerTopHeight = this.getElementHeight('.header__top');
      const subNav = document.querySelector('.inspiration-sub-nav-container');
      this.rend.setStyle(subNav, 'top', `${alertHeight + headerTopHeight}px`);
    } else {
      this.updateSubNavMargin();
    }
  }

  positionDeltaLogo(): void {
    if (!this.isInspireMenu) return;
    const inspireSubNav = document.querySelector(
      '.inspiration-sub-nav-container'
    );
    const deltaLogoContainer = document.querySelector('.delta-logo-container');
    if (inspireSubNav && deltaLogoContainer) {
      this.rend.setStyle(
        deltaLogoContainer,
        'margin-top',
        `${this.calculateTotalHeightAboveLogo() + 1}px`
      );
    }
  }

  private calculateTotalHeightAboveLogo(): number {
    const alertHeight = this.getElementHeight(
      '.idp-alert-advisories-container'
    );
    const navHeight = this.getElementHeight('.header__top');
    const bookingTabsHeight = this.getElementHeight('.header__booking');
    const widgetHeight = this.inspirationSubNavClicked
      ? 0
      : this.getElementHeight('.header__widgets');
    return (
      alertHeight +
      navHeight +
      bookingTabsHeight +
      widgetHeight +
      this.getElementHeight('.inspiration-sub-nav-container')
    );
  }
}
